// Evidence images shown on the Enrichment tab: what Chargeback has already
// prepared for the packet (source 'prepared'), plus the merchant's own manual
// uploads (source 'merchant', added locally on the detail page). Prepared demo
// entries carry extension-less backend-style URLs, the same shape Configure's
// seeded locker uploads have, so QuestionField renders them identically there
// and here: the dragger with the filename chip underneath. A fresh upload (a
// data URL) flips to the thumbnail preview card, again matching Configure.

// The image TYPES a dispute can carry, one image per type (mirrors the Configure
// locker's named-slot model, so each image lands in a known place in the PDF).
// Labels are competitor-sourced placeholders, same deal as the enrichment field list:
// they demo the shape and will be replaced with the real taxonomy later.
export const EVIDENCE_IMAGE_TYPES = [
  { key: "refund_policy", label: "Refund policy" },
  { key: "delivery_confirmation_photo", label: "Delivery Confirmation Photo" },
  { key: "delivery_label", label: "Delivery Label" },
  { key: "delivery_in_transit", label: "Delivery - In Transit" },
  { key: "consent_terms_conditions", label: "Consent to Terms & Conditions" },
  { key: "correspondence_with_supplier", label: "Correspondence with Supplier" },
  { key: "return_label", label: "Return Label" },
  { key: "accurate_description", label: "Accurate description" },
  { key: "transaction_receipt", label: "Transaction Receipt" },
  { key: "support_not_contacted", label: "Support Not Contacted" },
  { key: "payment_settings", label: "Payment Settings" },
  { key: "order_ready_for_pickup", label: "Order ready for pickup" },
  { key: "subscription_renewal_notice", label: "Subscription Renewal Notice" },
  { key: "proof_of_refund", label: "Proof of Refund" },
  { key: "delivery_confirmation_email", label: "Delivery Confirmation Email" },
  { key: "proof_of_usage", label: "Proof of Usage" },
  { key: "proof_of_provision", label: "Proof of Provision" },
  { key: "signed_contract_agreement", label: "Signed Contract/Agreement" },
  { key: "cardholder_communications", label: "Cardholder Communications" },
  { key: "order_shipped_notification", label: "Order shipped notification" },
  { key: "order_arrival_notification", label: "Order arrival notification" },
  { key: "late_delivery_notification", label: "Late Delivery Notification" },
  { key: "order_confirmation", label: "Order Confirmation" },
  { key: "proof_of_delivery", label: "Proof of Delivery" },
  { key: "dispute_risk_score", label: "Dispute Risk Score" }
]
export const EVIDENCE_IMAGE_TYPE_COUNT = EVIDENCE_IMAGE_TYPES.length

// Grouped the way Configure's Evidence locker groups its upload slots, so the
// Images sub-tab reads as the same kind of page: a handful of titled groups of
// labeled upload fields, not one 25-item wall.
export const EVIDENCE_IMAGE_GROUPS = [
  {
    key: "order_payment",
    label: "Order & payment",
    types: [
      "order_confirmation",
      "transaction_receipt",
      "payment_settings",
      "subscription_renewal_notice",
      "proof_of_refund"
    ]
  },
  {
    key: "delivery_fulfillment",
    label: "Delivery & fulfillment",
    types: [
      "delivery_confirmation_photo",
      "delivery_confirmation_email",
      "delivery_label",
      "delivery_in_transit",
      "order_shipped_notification",
      "order_arrival_notification",
      "order_ready_for_pickup",
      "late_delivery_notification",
      "proof_of_delivery",
      "return_label"
    ]
  },
  {
    key: "customer_communication",
    label: "Customer communication",
    types: ["cardholder_communications", "correspondence_with_supplier", "support_not_contacted"]
  },
  {
    key: "policies_consent",
    label: "Policies & consent",
    types: [
      "refund_policy",
      "consent_terms_conditions",
      "signed_contract_agreement",
      "accurate_description"
    ]
  },
  {
    key: "usage_risk",
    label: "Usage & risk",
    types: ["proof_of_usage", "proof_of_provision", "dispute_risk_score"]
  }
]
// Filled = entries whose type is a known slot (one image per type).
export const evidenceImageFillCount = (images) =>
  (Array.isArray(images) ? images : []).filter((i) =>
    EVIDENCE_IMAGE_TYPES.some((tp) => tp.key === i.type)
  ).length
